'use client';

import Link from 'next/link';
import { AgimaLogo } from '@/components/brand/AgimaLogo';
import { ThemeToggle } from '@/components/ThemeToggle';
import { ru } from '@/lib/ru';
import styles from '../AgimaEntryShell.module.css';

export function AgimaRoomHeader(props: { roomName: string; showAdminLink?: boolean }) {
  return (
    <header className={`${styles.top} ${styles.roomTop}`}>
      <Link className={styles.brand} href="/" target="_blank" rel="noopener">
        <AgimaLogo className={styles.logo} />
        <span className={styles.product}>Meet</span>
      </Link>
      <p className={styles.roomName}>{props.roomName}</p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          justifySelf: 'end',
        }}
      >
        {props.showAdminLink ? (
          // /admin is served by octor-backend, not a Next.js route.
          // eslint-disable-next-line @next/next/no-html-link-for-pages
          <a className={styles.navLink} href="/admin/" target="_blank" rel="noopener">
            {ru.admin}
          </a>
        ) : null}
        <ThemeToggle />
      </div>
    </header>
  );
}
